import React from 'react';
import styles from './Frame.module.scss';
import { Icon, SpriteFrame } from 'components';
import { icons } from 'assets';
import { FrameProps } from './types';

const Frame = (props: FrameProps) => {
  const {
    frameNumber,
    onMouseEnter,
    onMouseLeave,
    isFrameCut = false,
    onFocus = false,
    onClick
  } = props;

  return (
    <div
      className={styles.frameContainer}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      onClick={onClick}
    >
      <div className={onFocus
        ? styles.cutterBttn
        : [styles.cutterBttn, styles.hidden].join(' ')
      }>
        <div className={styles.line} />
        <Icon icon={icons.scissors} />
        <div className={styles.line} />
      </div>
      <SpriteFrame
        frameNumber={frameNumber}
        showNumber
        className={isFrameCut ? styles.cutFrame : styles.frame}
      />
    </div>
  );
};

const arePropsEqual = (prevProps, nextProps) => {
  if (prevProps.isFrameCut !== nextProps.isFrameCut) return false;
  if (prevProps.onFocus !== nextProps.onFocus) return false;
  return true;
};

export default React.memo(Frame, arePropsEqual);
